export const variants = {
  initial: { opacity: 0, x: 200 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -200 },
}

export const animationBase = {
  variants: variants,
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
}
